const FooterNavData = [
    {
        title: "Links",
        items: [
            { label: "Home", href: "/" },
            { label: "Treatments", href: "/Treatments" },
            { label: "Packages", href: "/Packages" },
            { label: "Contact Us", href: "/Contact-us" },
        ],
    },
    {
        title: "Company",
        items: [
            { label: "About us", href: "/About-us" },
            { label: "Gallery", href: "/Gallery" },
            { label: "FAQs", href: "/faq" },
        ],
    },
    {
        title: "Resource",
        items: [
            { label: "Blog", href: "/blog" },
            { label: "Help center", href: "/help-center" },
        ],
    },
];
export default FooterNavData